import * as React from 'react';
import Modal from 'react-bootstrap/Modal';
import ConfirmPopup from './ConfirmPopup';
import { toast } from 'react-toastify';
import { GetQuery, PostFormDataQuery, PostQuery } from './Shared';
import type { AppFile } from './models/JobSharedInterfaces';

interface DriverJobsPhotosProps {
    jobId: number;
    showModal: boolean;
    hideModal(): void;
}

const DriverJobsPhotosModal = (props: DriverJobsPhotosProps) => {
    const [loading, setLoading] = React.useState(true);
    const [uploadedFiles, setUploadedFiles] = React.useState<AppFile[]>([]);
    const [deleteIndex, setDeleteIndex] = React.useState(-1);
    const [showConfirmModal, setShowConfirm] = React.useState(false);
    const [modalSaveDisabled, setModalSaveDisabled] = React.useState(false);

    React.useEffect(() => {
        getData(props.jobId);
    }, [props.jobId]);

    const getData = async (jobId: number) => {
        const apiUrl = "GetDriverJobPhotos?JobId=" + jobId;
        var result = await GetQuery(apiUrl);

        if (result.error) {
            toast.error("Error getting data!");
        } else {
            setUploadedFiles(result.data);
            setLoading(false);
        };
    }

    const hideModal = () => {
        props.hideModal();
    }

    const handleImportFile = (e: any) => {
        setLoading(true);
        importPhotos(e.target.files);
    }

    const importPhotos = async (files: File[]) => {
        //save photos
        const filedata = new FormData()
        filedata.append('jobId', props.jobId.toString());

        for (var i = 0; i < files.length; i++) {
            filedata.append('photos', files[i]);
        }

        const apiUrl = "SaveJobPhotos";
        var result = await PostFormDataQuery(apiUrl, filedata);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                //save the returned photos
                var uploadedFileList = [...uploadedFiles];
                var photos = result.data;

                for (var p = 0; p < photos.length; p++) {
                    var photo = photos[p];
                    uploadedFileList.push(photo);
                }
                setUploadedFiles(uploadedFileList);
                setLoading(false);
                toast.success("Photos have been uploaded");
            };
        }
    }

    //DELETE
    const deletePhoto = (e: any, itemIndex: number) => {
        e.preventDefault();
        setDeleteIndex(itemIndex);
        setShowConfirm(true);
        setModalSaveDisabled(false);
    }

    const hideConfirmModal = () => {
        setDeleteIndex(-1);
        setShowConfirm(false);
        setModalSaveDisabled(false);
    }

    const saveConfirmModal = () => {
        if (modalSaveDisabled) {
            return;
        }

        deleteJobPhoto();
    }

    const deleteJobPhoto = async () => {
        var photos = [...uploadedFiles];
        var photo = photos[deleteIndex];

        var photoIds: number[] = [];
        photoIds.push(photo.id);

        var deletePhoto = {
            photoIds: photoIds
        };

        //delete photo
        var jsonItem = JSON.stringify(deletePhoto);

        const apiUrl = "DeleteJobPhotos";
        var result = await PostQuery(apiUrl, jsonItem);
        if (result.error) {
            toast.error("Error saving data!");
        } else {
            if (result.data.isError) {
                var errors = result.data.messages as any[];
                errors.map(function (error: any) {
                    toast.error(error.content);
                });
            } else {
                photos.splice(deleteIndex, 1);
                setUploadedFiles(photos);
                setDeleteIndex(-1);
                setShowConfirm(false);
                setModalSaveDisabled(true);
                toast.success("Photo has been deleted");
            }
        };
    }
    //END DELETE


    const confirmPopup = <ConfirmPopup heading="Delete Photo?" text="Are you sure you want to delete this photo?" hideConfirmModal={hideConfirmModal} showConfirmModal={showConfirmModal} saveConfirmModal={saveConfirmModal} />

    return (
        <div>
            <div className="static-modal">
                {confirmPopup}
            </div>
            <Modal size="lg" show={props.showModal} onHide={hideModal}>
                <Modal.Header className="modal__header--colour">
                    <Modal.Title>Upload Photo/s</Modal.Title>
                    <button type="button" className="close modal__close--colour" onClick={hideModal}>&times;</button>
                </Modal.Header>
                <Modal.Body>
                    <div className={loading ? "hidden" : "marginTop10"}>
                        <input type="file" className="marginBottom10" name="file" accept="image/*" onChange={handleImportFile} multiple />
                    </div>
                    <div className={uploadedFiles.length === 0 || loading ? "hidden" : ""}>
                        <hr></hr>
                        {uploadedFiles.map((uploadedFile, index) =>
                            <div key={index} className="marginBottom10" >
                                <div className="photoImport__deleteParent--position">
                                    <a className="makeitred photoImport__delete--position" href="#" onClick={(e) => deletePhoto(e, index)}>
                                        <span className="fas fas fa-times-circle mobileMenuSize alignIconCenter"></span>
                                    </a>
                                    <img className="mobile-width" src={uploadedFile.id > 0 ? "data:" + uploadedFile.fileType + ";base64," + uploadedFile.content : uploadedFile.content}></img>
                                </div>
                            </div>
                        )}
                    </div>

                    <div className={loading ? "marginTop10" : "hidden"}>
                        <span>Loading Photos...</span>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <button className="popup-button--yes" onClick={hideModal} disabled={loading}>Close</button>
                </Modal.Footer>
            </Modal>
        </div>
    )
}

export default DriverJobsPhotosModal;